export const CANCELLATION_REASON_FREE_TEXT_MAX_LEN = 500;

export enum CancellationReasonCode {
  TooExpensive = 'tooExpensive',
  RarelyDrivingCar = 'rarelyDrivingCar',
  DoesNotHaveACarAnymore = 'doesNotHaveACarAnymore',
  HasRoadAssistanceViaInsuranceOrGuarantee = 'hasRoadAssistanceViaInsuranceOrGuarantee',
  HasChosenAnotherProvider = 'hasChosenAnotherProvider',
  DissatisfiedWithService = 'dissatisfiedWithService',
  Other = 'other',
}

export const CANCELLATION_REASON_CODES: CancellationReasonCode[] = [
  CancellationReasonCode.TooExpensive,
  CancellationReasonCode.RarelyDrivingCar,
  CancellationReasonCode.DoesNotHaveACarAnymore,
  CancellationReasonCode.HasRoadAssistanceViaInsuranceOrGuarantee,
  CancellationReasonCode.HasChosenAnotherProvider,
  CancellationReasonCode.DissatisfiedWithService,
  CancellationReasonCode.Other,
];

export class CancellationReason {
  predefined: CancellationReasonCode[];
  freeText?: string;

  constructor(json: any) {
    this.predefined = Array.isArray(json?.predefined) ? json.predefined : [];
    const freeText = typeof json?.freeText === 'string' ? json.freeText.trim() : '';
    this.freeText = freeText.length > 0 ? freeText : undefined;
  }

  hasContent(): boolean {
    return this.predefined.length > 0 || Boolean(this.freeText);
  }

  static fromForm(code?: CancellationReasonCode | null, freeText?: string | null): CancellationReason | undefined {
    const reason = new CancellationReason({
      predefined: code ? [code] : [],
      freeText,
    });
    return reason.hasContent() ? reason : undefined;
  }
}
